export default "__VITE_ASSET__CQw2jmla__";